/**
 * ORE Utensili – Product Description Parser v2.3 (fix)
 *
 * Spacchetta la descrizione prodotto generata da POolipo in 6 sezioni:
 * 1. Descrizione principale
 * 2. Tabella specifiche
 * 3. FAQ
 * 4. Vantaggi per l'utilizzatore
 * 5. Utente ideale
 * 6. Perché sceglierlo
 *
 * Gestisce:
 *  - tag <b> semplici (es. <p><b>FAQ</b></p>)
 *  - tag <h2> con <b> dentro (es. <h2><b>Vantaggi per l'utilizzatore</b></h2>)
 *  - descrizioni in TESTO SEMPLICE senza alcun tag HTML (fix v2.1)
 *  - descrizioni con marcatori in <div> invece di <p>, e grassetto via
 *    style="font-weight: bold" su <span> invece di <b>/<strong> (fix v2.2)
 *  - titoli "nudi" senza alcuna formattazione bold, purché il testo
 *    combaci con una keyword nota, es. <div>Ideale per chi</div> (fix v2.2)
 *
 * FIX v2.1:
 *  - Il parser ora gestisce i text node "nudi" (descrizioni senza <p>),
 *    wrappandoli automaticamente in un <p> invece di scartarli.
 *  - hideShopifySection() ora si ferma se l'elemento da nascondere si trova
 *    dentro una sezione "critica" (quella con il form di acquisto/il prezzo),
 *    per evitare di nascondere per errore titolo/prezzo/bottone Aggiungi al
 *    carrello quando la sola descrizione risulta vuota o non standard.
 *
 * FIX v2.2:
 *  - getSectionKey() ora riconosce anche i <div> (non solo i <p>) come
 *    possibili titoli di sezione.
 *  - Il grassetto viene riconosciuto anche via inline style
 *    ("font-weight: bold" o >= 600), non solo tramite tag <b>/<strong>.
 *  - Un blocco breve (<p> o <div>) senza formattazione bold ma il cui
 *    testo combacia esattamente con una keyword nota viene comunque
 *    trattato come titolo di sezione (necessario per marcatori "nudi"
 *    come <div>Ideale per chi</div>).
 *  - Aggiunta la keyword "contenuto della confezione" come alias della
 *    sezione "vantaggi", per gestire descrizioni (es. Makita) che
 *    includono questo blocco extra non presente nel formato Bosch.
 *
 * FIX v2.3:
 *  - Il rilevamento della tabella ora cerca un <table> anche tra i
 *    discendenti dell'elemento (non solo sul tag diretto), perché in
 *    alcune descrizioni (es. Makita) la tabella è avvolta in un <div>
 *    wrapper: <div><table>...</table></div>. Prima di questo fix, in
 *    quel caso la tabella veniva trattata come contenuto normale e
 *    finiva appesa alla sezione attiva in quel punto del documento
 *    (es. "vantaggi") invece di finire in "Specifiche tecniche".
 */

(function () {
  'use strict';

  // ─── Selettori DOM ─────────────────────────────────────────────────────────
  const SOURCE_SELECTOR = '.product--short-description, .product__description, .product-description, [data-product-description], .description__content';

  const TARGETS = {
    description:  '#ore-section-description',
    tabella:      '#ore-section-tabella',
    faq:          '#ore-section-faq',
    vantaggi:     '#ore-section-vantaggi',
    utente:       '#ore-section-utente',
    perche:       '#ore-section-perche'
  };

  // Selettori usati per riconoscere una sezione "critica" che non va MAI
  // nascosta interamente (contiene prezzo / variant picker / add to cart).
  const CRITICAL_SECTION_SELECTOR = 'form[action*="/cart/add"], .shopify-payment-button, [data-product-form], .price, .product-form__buy-buttons';

  // ─── Keywords per identificare le sezioni ──────────────────────────────────
  // Ordine importante: le keyword più specifiche prima di quelle generiche
  const SECTION_KEYWORDS = [
    { key: 'faq',      words: [
        'faq'
    ]},
    { key: 'vantaggi', words: [
        'vantaggi per l',              // vantaggi per l'utilizzatore
        'vantaggi chiave',             // vantaggi chiave
        'vantaggi della',              // vantaggi della batteria...
        'caratteristiche principali',  // caratteristiche principali della...
        'contenuto della confezione',  // fix v2.2 - blocco extra tipo Makita
        'vantaggi'                     // generico
    ]},
    { key: 'utente',   words: [
        'utente ideale',
        'ideale per chi',
        'applicazioni consigliate', // applicazioni consigliate
        'ideale per'            // generico (dopo gli altri)
    ]},
    { key: 'perche',   words: [
        'perche sceglier',      // perché sceglierlo / perché scegliere
        'perfetto per',         // è perfetto per:
        'e perfetto per'
    ]}
  ];



  // ─── Utility ───────────────────────────────────────────────────────────────
  function stripEmoji(str) {
    return (str || '').replace(/[\u{1F000}-\u{1FFFF}\u{2600}-\u{27FF}\u{2300}-\u{23FF}\u{FE00}-\u{FE0F}✅✨🎯👷🏠🔋💡🛡️🔄✔️]/gu, '').trim();
  }

  function norm(str) {
    return stripEmoji(str || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  }

  function isEmpty(el) {
    if (!el) return true;
    const t = el.textContent.trim();
    const h = el.innerHTML.trim();
    return t === '' || h === '&nbsp;' || h === '<br>' || h === '<br/>';
  }

  // fix v2.2 — riconosce il grassetto sia via tag (<b>/<strong>) sia via
  // inline style (style="font-weight: bold" o un peso numerico >= 600),
  // sia sull'elemento stesso sia su un suo discendente diretto.
  function isBoldEl(el) {
    if (!el) return false;
    if (/^(B|STRONG)$/.test(el.tagName)) return true;
    const style = (el.getAttribute && el.getAttribute('style')) || '';
    const m = style.match(/font-weight\s*:\s*([a-z0-9]+)/i);
    if (m) {
      const w = m[1].toLowerCase();
      if (w === 'bold' || w === 'bolder' || (/^\d+$/.test(w) && parseInt(w, 10) >= 600)) {
        return true;
      }
    }
    return false;
  }

  function findBoldDescendant(el) {
    if (isBoldEl(el)) return el;
    if (!el.querySelectorAll) return null;
    const candidates = el.querySelectorAll('b, strong, [style*="font-weight"]');
    for (const c of candidates) {
      if (isBoldEl(c)) return c;
    }
    return null;
  }

  // Riconosce un titolo di sezione da:
  // - <p><b>...</b></p> / <div><span style="font-weight:bold">...</span></div>
  // - <h2> o <h3> qualsiasi  es. <h2>Vantaggi della batteria...</h2>
  // - <p>/<div> breve con emoji  es. <p>✅ Vantaggi chiave</p>
  // - <p><b> con testo che termina con ":"  es. <p><b>Perfetto per:</b></p>
  // - <p>/<div> breve SENZA bold il cui testo combacia con una keyword nota,
  //   es. <div>Ideale per chi</div> (fix v2.2)
  function getSectionKey(el) {
    const tag = el.tagName;
    const isHeading = /^H[1-6]$/.test(tag);
    const isBlockTag = tag === 'P' || tag === 'DIV'; // fix v2.2: anche DIV

    // Elemento (o discendente) in grassetto che copre tutto il testo del blocco
    const boldEl = isBlockTag ? findBoldDescendant(el) : null;
    const isBoldBlock = isBlockTag && boldEl &&
      el.textContent.trim().length < 80 &&
      norm(el.textContent) === norm(boldEl.textContent);

    // Blocco breve senza elementi complessi = possibile titolo, anche senza
    // bold (fix v2.2): il match sulla keyword più sotto fa da garanzia contro
    // i falsi positivi.
    const isShortBlock = isBlockTag &&
      el.textContent.trim().length < 80 &&
      !el.querySelector('a, img, ul, ol, table');

    if (!isHeading && !isBoldBlock && !isShortBlock) return null;

    const text = norm(stripEmoji(el.textContent));

    // Cerca match nelle keyword (ordine importante: più specifiche prima)
    for (const { key, words } of SECTION_KEYWORDS) {
      if (words.some(w => text.includes(norm(w)))) return key;
    }
    return null;
  }

  // ─── Parser principale ─────────────────────────────────────────────────────
  function parseDescription(sourceEl) {
    const nodes = Array.from(sourceEl.childNodes).filter(n => {
      if (n.nodeType === Node.TEXT_NODE) return n.textContent.trim() !== '';
      if (n.nodeType === Node.ELEMENT_NODE) return !isEmpty(n);
      return false;
    });

    const blocks = {
      description: [],
      tabella:     [],
      faq:         [],
      vantaggi:    [],
      utente:      [],
      perche:      []
    };

    let currentSection = 'description';

    nodes.forEach(node => {
      // FIX v2.1: i text node "nudi" (descrizione senza HTML) venivano
      // scartati qui con un return anticipato. Ora li wrappiamo in un <p>
      // e li trattiamo come contenuto normale della sezione corrente.
      if (node.nodeType === Node.TEXT_NODE) {
        const p = document.createElement('p');
        p.textContent = node.textContent.trim();
        blocks[currentSection].push(p);
        return;
      }

      if (node.nodeType !== Node.ELEMENT_NODE) return;
      const el = node;

      // Tabella → sempre in tabella.
      // fix v2.3: la tabella a volte non è un figlio diretto della
      // descrizione ma è avvolta in un wrapper (es. <div><table>...</table></div>,
      // come nella descrizione Makita). Cerchiamo quindi una <table> anche
      // tra i discendenti dell'elemento corrente, non solo sul tag diretto.
      const nestedTable = el.tagName === 'TABLE' ? el : (el.querySelector && el.querySelector('table'));
      if (nestedTable) {
        blocks.tabella.push(nestedTable.cloneNode(true));
        return;
      }

      // Controlla se è un titolo di sezione
      const sectionKey = getSectionKey(el);
      if (sectionKey) {
        currentSection = sectionKey;
        return; // il titolo stesso non va nel contenuto (lo mostriamo nel template)
      }

      // Smista nel blocco corrente
      blocks[currentSection].push(el.cloneNode(true));
    });

    return blocks;
  }

  // ─── Render: lista generica di nodi ────────────────────────────────────────
  function renderNodes(nodeList, wrapperClass) {
    const wrapper = document.createElement('div');
    wrapper.className = wrapperClass;
    nodeList.forEach(n => wrapper.appendChild(n));
    return wrapper;
  }

  // ─── Render: Vantaggi (immagine sx + lista dx + titolo sopra) ──────────────
  function renderVantaggi(nodeList) {
    const wrapper = document.createElement('div');
    wrapper.className = 'ore-vantaggi-wrapper';

    // Griglia immagine + contenuto
    const inner = document.createElement('div');
    inner.className = 'ore-vantaggi-inner';

    // Immagine sinistra
    const img = document.createElement('div');
    img.className = 'ore-vantaggi-image';

    // Contenuto destra
    const content = document.createElement('div');
    content.className = 'ore-vantaggi-content';

    const ul = document.createElement('ul');
    ul.className = 'ore-vantaggi-list';

    nodeList.forEach(node => {
      if (node.tagName === 'UL') {
        Array.from(node.querySelectorAll('li')).forEach(li => {
          ul.appendChild(li.cloneNode(true));
        });
      } else {
        const text = node.textContent.trim();
        if (text && text !== '\u00a0') {
          const li = document.createElement('li');
          li.innerHTML = node.innerHTML;
          ul.appendChild(li);
        }
      }
    });

    // Titolo sopra la lista nel pannello destro
    const heading = document.createElement('h2');
    heading.className = 'ore-section-heading';
    heading.textContent = "Vantaggi per l’utilizzatore";
    content.appendChild(heading);

    if (ul.children.length > 0) content.appendChild(ul);
    inner.appendChild(img);
    inner.appendChild(content);
    wrapper.appendChild(inner);
    return wrapper;
  }

  // ─── Render: Utente ideale ──────────────────────────────────────────────────
  function renderUtente(nodeList) {
    const wrapper = document.createElement('div');
    wrapper.className = 'ore-utente-wrapper';

    const intro = document.createElement('p');
    intro.className = 'ore-utente-intro';

    const ul = document.createElement('ul');
    ul.className = 'ore-utente-list';

    const outro = document.createElement('p');
    outro.className = 'ore-utente-outro';

    let hasIntro = false;

    nodeList.forEach(node => {
      if (node.tagName === 'UL') {
        Array.from(node.querySelectorAll('li')).forEach(li => ul.appendChild(li.cloneNode(true)));
        return;
      }
      const text = node.textContent.trim();
      if (!text || text === '\u00a0') return;

      // Prima frase lunga prima della lista = intro
      if (!hasIntro && ul.children.length === 0 && text.length > 40) {
        intro.innerHTML = node.innerHTML;
        hasIntro = true;
      // Frase lunga dopo la lista = outro
      } else if (ul.children.length > 0 && text.length > 40) {
        outro.innerHTML = node.innerHTML;
      // Frasi brevi = card
      } else if (text.length <= 40) {
        const li = document.createElement('li');
        li.textContent = text;
        ul.appendChild(li);
      }
    });

    if (intro.innerHTML) wrapper.appendChild(intro);
    if (ul.children.length > 0) wrapper.appendChild(ul);
    if (outro.innerHTML) wrapper.appendChild(outro);
    return wrapper;
  }

  // ─── Render: Perché sceglierlo (lista disc nera, centrata) ─────────────────
  function renderPerche(nodeList) {
    const wrapper = document.createElement('div');
    wrapper.className = 'ore-perche-wrapper';
    const ul = document.createElement('ul');
    ul.className = 'ore-perche-list';

    nodeList.forEach(node => {
      if (node.tagName === 'UL') {
        Array.from(node.querySelectorAll('li')).forEach(li => ul.appendChild(li.cloneNode(true)));
      } else {
        const text = node.textContent.trim();
        if (text && text !== '\u00a0') {
          const li = document.createElement('li');
          li.textContent = text;
          ul.appendChild(li);
        }
      }
    });

    if (ul.children.length > 0) wrapper.appendChild(ul);
    return wrapper;
  }

  // ─── Render: FAQ accordion ─────────────────────────────────────────────────
  function renderFAQ(nodeList) {
    const wrapper = document.createElement('div');
    wrapper.className = 'ore-faq-wrapper';

    const items = nodeList.filter(n => {
      const t = n.textContent.trim();
      return t !== '' && n.innerHTML.trim() !== '&nbsp;';
    });

    let i = 0;
    while (i < items.length) {
      const node = items[i];
      const text = node.textContent.trim();
      const startsWithNum = /^\d+[\.\)]/.test(text);

      if (i + 1 < items.length) {
        const nextText = items[i + 1].textContent.trim();
        const nextIsAnswer = !(/^\d+[\.\)]/.test(nextText)) && nextText.length > 0;

        if (startsWithNum || nextIsAnswer) {
          const questionText = text.replace(/^\d+[\.\)]\s*/, '');
          const answerText = nextIsAnswer ? nextText : '';

          const faqItem = document.createElement('div');
          faqItem.className = 'ore-faq-item';

          const q = document.createElement('button');
          q.className = 'ore-faq-question';
          q.setAttribute('aria-expanded', 'false');
          q.innerHTML = `<span>${questionText}</span><svg class="ore-faq-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>`;

          const a = document.createElement('div');
          a.className = 'ore-faq-answer';
          a.setAttribute('aria-hidden', 'true');
          const p = document.createElement('p');
          p.textContent = answerText;
          a.appendChild(p);

          q.addEventListener('click', function () {
            const isOpen = faqItem.classList.contains('is-open');
            wrapper.querySelectorAll('.ore-faq-item.is-open').forEach(el => {
              el.classList.remove('is-open');
              el.querySelector('.ore-faq-question').setAttribute('aria-expanded', 'false');
              el.querySelector('.ore-faq-answer').setAttribute('aria-hidden', 'true');
            });
            if (!isOpen) {
              faqItem.classList.add('is-open');
              q.setAttribute('aria-expanded', 'true');
              a.setAttribute('aria-hidden', 'false');
            }
          });

          faqItem.appendChild(q);
          faqItem.appendChild(a);
          wrapper.appendChild(faqItem);
          i += nextIsAnswer ? 2 : 1;
          continue;
        }
      }
      i++;
    }

    return wrapper;
  }

  // ─── Render: Tabella ───────────────────────────────────────────────────────
  function renderTabella(nodeList) {
    const wrapper = document.createElement('div');
    wrapper.className = 'ore-table-wrapper';
    nodeList.forEach(n => wrapper.appendChild(n));
    return wrapper;
  }

  // ─── FIX v2.1: rileva se un elemento è dentro una sezione "critica" ────────
  // Una sezione è "critica" se contiene il form di acquisto, il prezzo o il
  // bottone di pagamento: non va MAI nascosta interamente, anche se il blocco
  // di descrizione al suo interno risulta vuoto.
  function isInsideCriticalSection(sectionEl) {
    if (!sectionEl) return false;
    return !!sectionEl.querySelector(CRITICAL_SECTION_SELECTOR);
  }

  // ─── Nascondi sezione Shopify ─────────────────────────────────────────────
  function hideShopifySection(el) {
    let node = el;
    while (node && node !== document.body) {
      if (node.classList && node.classList.contains('shopify-section')) {
        // FIX v2.1: se questa shopify-section contiene anche il form
        // d'acquisto / il prezzo (es. main-product), NON la nascondiamo:
        // nascondiamo solo il singolo blocco vuoto (es. il div della
        // descrizione), lasciando intatto il resto della sezione.
        if (isInsideCriticalSection(node)) {
          console.warn('[ORE Parser] Sezione critica rilevata: nascondo solo il blocco vuoto, non l\'intera sezione.', el);
          el.style.display = 'none';
          return;
        }
        node.style.display = 'none';
        return;
      }
      node = node.parentElement;
    }
    // Se non troviamo nessuna .shopify-section (caso limite), nascondiamo
    // comunque solo l'elemento stesso, mai qualcosa di più ampio.
    el.style.display = 'none';
  }

  // ─── Inject nei target ─────────────────────────────────────────────────────
  function inject(blocks) {
    const map = {
      description: { el: document.querySelector(TARGETS.description), render: nodes => renderNodes(nodes, 'ore-description-wrapper') },
      tabella:     { el: document.querySelector(TARGETS.tabella),     render: renderTabella },
      faq:         { el: document.querySelector(TARGETS.faq),         render: renderFAQ },
      vantaggi:    { el: document.querySelector(TARGETS.vantaggi),    render: renderVantaggi },
      utente:      { el: document.querySelector(TARGETS.utente),      render: renderUtente },
      perche:      { el: document.querySelector(TARGETS.perche),      render: renderPerche }
    };

    Object.entries(map).forEach(([key, { el, render }]) => {
      if (!el) return;
      const hasContent = blocks[key] && blocks[key].length > 0;
      if (hasContent) {
        el.innerHTML = '';
        el.appendChild(render(blocks[key]));
      } else {
        hideShopifySection(el);
      }
    });
  }

  // ─── Init ──────────────────────────────────────────────────────────────────
  function init() {
    const sourceEl = document.querySelector(SOURCE_SELECTOR);
    if (!sourceEl) {
      console.warn('[ORE Parser] Descrizione non trovata:', SOURCE_SELECTOR);
      return;
    }

    const hasTargets = Object.values(TARGETS).some(sel => document.querySelector(sel));
    if (!hasTargets) return;

    const blocks = parseDescription(sourceEl);
    inject(blocks);
    sourceEl.style.display = 'none';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();